import { Mutations } from "@/store/enums/StoreEnums";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import {
  TablesAttrKey,
  UserSettings,
} from "@/core/services/api/interfaces/local/UserSettingsInterface";
import UserService from "@/core/services/UserService";
import IHeaderConfiguration from "@/core/services/api/interfaces/local/IHeaderConfiguration";
import { TableColumn } from "@/core/services/api/interfaces/local/Columns";

const allEnumValues = (enumObject: object) => Object.values(enumObject);

@Module
export default class UserSettingsModule extends VuexModule {
  _userSettings = UserService.getUserSettings();

  @Mutation
  [Mutations.COMMON_USER_SETTINGS_UPDATE](settings?: UserSettings) {
    UserService.saveUserSettings(settings || this._userSettings);
  }

  get userSettings(): UserSettings {
    const userSettings = this._userSettings;
    if (userSettings instanceof UserSettings) {
      return userSettings;
    }

    return new UserSettings(userSettings);
  }

  get userSettingsTableAllColumns() {
    const settings = this.userSettings;
    console.log(settings);

    return (
      table: TablesAttrKey,
      formatter: (column: TableColumn) => { name: string; key: string }
    ) => {
      const selected = settings.getTableColumns(table);
      const enumClass = settings.getTableColumnsEnum(table);

      const allColumnsEnum = allEnumValues(enumClass);

      return Object.values(allColumnsEnum)
        .sort((a, b) => {
          const aI = selected.indexOf(a);
          const bI = selected.indexOf(b);
          if (aI < 0) {
            return 100;
          }
          if (bI < 0) {
            return -100;
          }

          return aI - bI;
        })
        .map(formatter);
    };
  }

  get userSettingsTableHeaders() {
    const settings = this.userSettings;

    return (
      table: TablesAttrKey,
      filter: (column: TableColumn) => boolean,
      formatter: (column: TableColumn) => IHeaderConfiguration
    ) => settings.getTableColumns(table).filter(filter).map(formatter);
  }
}
